// src/components/dashboard/client/ClientDocuments.js - VERSION SIMPLIFIÉE ET COMPLÈTE
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, User } from 'lucide-react';
import DocumentsManager from '../shared/DocumentsManager';

const ClientDocuments = () => {
  const { dossierId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Client */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate(`/client/${dossierId}`)}
                className="flex items-center text-gray-600 hover:text-gray-900"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Retour au tableau de bord
              </button>
              <div className="h-6 w-px bg-gray-300"></div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 flex items-center">
                  <Download className="w-6 h-6 mr-2 text-blue-600" />
                  Espace téléchargements
                </h1>
                <p className="text-gray-600">Gérez et partagez les documents importants de votre projet</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                <User className="w-4 h-4 mr-1" />
                Client
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Message d'accueil pour les clients */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <Download className="w-5 h-5 text-green-500 mt-0.5 mr-3" />
            <div>
              <h3 className="text-sm font-medium text-green-900">Bienvenue dans votre espace documents</h3>
              <p className="text-sm text-green-700 mt-1">
                Retrouvez ici tous les documents liés à votre projet : contrats, photos, rapports de production, 
                certificats et manuels. Vous pouvez télécharger, commenter et suivre l'évolution de votre dossier.
              </p>
            </div>
          </div>
        </div>

        {/* Gestionnaire de documents avec privilèges client */}
        <DocumentsManager 
          dossierId={dossierId}
          isAdmin={false}
          canEdit={false}
          showInternalDocs={false}
        />
      </div>
    </div>
  );
};

export default ClientDocuments;